;(function(){

	var
		block = 'modal',
		active = false,
		$scroll = $('.site-scroll'),
		onResize = function() {

			var windowHeight = window.innerHeight;

			if (!active) {
				return;
			}

			$scroll.css('height', windowHeight);
			$(bem.selector(block, 'wrapper')).css('height', windowHeight);

		};

	$core.body
		.on(bem.event(block, 'open'), function(e) {

			var scrollTop = $core.body.scrollTop() || $core.html.scrollTop();
			active = true;

			onResize();

			$scroll.scrollTop(scrollTop);

		})
		.on(bem.event(block, 'close'), function(e) {

			var scrollTop = $scroll.scrollTop();
			active = false;

			$scroll.css('height', 'auto');
			$core.body.add($core.html).scrollTop(scrollTop);

		});

	$core.doc.scrollScope({
		forcedElements: bem.selector(block, 'scroll')
	});

	site.resize.test = onResize;
	onResize();

}());
